import { useEffect, useState } from "react";

/**
 * The four court tablets on one screen, for a test run with too few devices (his ask, 18 Oct):
 * /courts?t=rehearsal#tok1,tok2,tok3,tok4, the four courts' own tokens (each court has its own),
 * after the # so they never reach a server log; the setup page lists the link. Each quarter is the real tablet page
 * for its court in a frame, drawn at a tablet's size (1280 by 800) and scaled to fit, so taps,
 * scores and the clock are exactly what a tablet does. Each court keeps its own saved entry
 * (bd.court.<tournament>.<n>), so the four do not get in each other's way.
 */

const TABLET = { w: 1280, h: 800 };

export function CourtsAllView({ tokens }: { tokens: string[] }) {
  const [size, setSize] = useState(() => ({ w: window.innerWidth, h: window.innerHeight }));
  useEffect(() => {
    document.title = "Four courts";
    const on = (): void => setSize({ w: window.innerWidth, h: window.innerHeight });
    window.addEventListener("resize", on);
    return () => window.removeEventListener("resize", on);
  }, []);
  const gap = 6;
  const scale = Math.min((size.w - gap) / 2 / TABLET.w, (size.h - gap) / 2 / TABLET.h);
  const cell = { width: TABLET.w * scale, height: TABLET.h * scale };
  return (
    <main
      style={{
        display: "grid",
        gridTemplateColumns: `repeat(2, ${cell.width}px)`,
        gridTemplateRows: `repeat(2, ${cell.height}px)`,
        gap,
        justifyContent: "center",
        alignContent: "center",
        width: "100vw",
        height: "100dvh",
        overflow: "hidden",
        background: "#14204a",
      }}
    >
      {tokens.slice(0, 4).map((token, i) => (
        <div key={i} style={{ ...cell, overflow: "hidden", position: "relative" }}>
          <iframe
            title={`Court ${i + 1}`}
            src={`/c/${encodeURIComponent(token)}/${i + 1}${location.search}`}
            allow="fullscreen; screen-wake-lock; autoplay"
            style={{
              width: TABLET.w,
              height: TABLET.h,
              border: 0,
              transform: `scale(${scale})`,
              transformOrigin: "0 0",
              position: "absolute",
              inset: 0,
            }}
          />
        </div>
      ))}
    </main>
  );
}
